<template>
    <b-button pill variant="outline-danger" @event="$emit('click')">
        <i class="fa fa-trash mr-1"></i>{{ $t("button.delete_selection") }}
    </b-button>
</template>

<script>
    export default {
        name: "ButtonDelete",
    }
</script>

<style scoped>

</style>
